/**
 * TODO: Call vm.changePageSize(num: number) in the parent controller
 * Either use require of an & binding
 */
angular.module('app').component('itemsPerPage', {
    bindings: {
        onChanged: '&'
    },
    controllerAs: 'vm',
    controller: function () {
        let vm = this;
        vm.changePageSize = changePageSize;
        this.$onInit = function () {
            vm.itemsPerPage = 25;
        };
        this.$onChanges = function (changes) {
            if (changes.itemsPerPage) {
                vm.itemsPerPage = this.itemsPerPage;
            }
        };
        function changePageSize(pageSize) {
            vm.itemsPerPage = pageSize;
            this.onChanged({ value: pageSize });
        }
    },
    template: `
<span class="text-mono" uib-dropdown>
    <button type="button" class="btn btn-sm btn-info space-right" uib-dropdown-toggle>
        <span class="space-right">{{vm.itemsPerPage}} traces per page</span>
        <span class="caret"></span>
    </button>
    <ul uib-dropdown-menu role="menu">
        <li class="pointer" role="menuitem">
            <a ng-href="" ng-click="vm.changePageSize(10)">10</a>
        </li>
        <li class="pointer" role="menuitem">
            <a ng-href="" ng-click="vm.changePageSize(25)">25</a>
        </li>
        <li class="pointer" role="menuitem">
            <a ng-href="" ng-click="vm.changePageSize(50)">50</a>
        </li>
        <li class="pointer" role="menuitem">
            <a ng-href="" ng-click="vm.changePageSize(100)">100</a>
        </li>
    </ul>
</span>
`
});
